import { render, staticRenderFns } from "./WorkDescriptionsTable.vue?vue&type=template&id=a9f95a02"
import script from "./WorkDescriptionsTable.vue?vue&type=script&lang=ts"
export * from "./WorkDescriptionsTable.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports